<template>
  <div>
    <!-- <b-card
      class="mb-2 shadow"
      header="Factures"
      header-text-variant="light"
      header-tag="h6"
      bg-variant="secondary"
    > -->
      <b-table
        v-if="invoices.length > 0"
        id="invoicesTable"
        striped
        small
        hover
        :fields="invoicesFields"
        :items="invoices"
      >
        <template v-slot:cell(date)="data">{{ toDate(data.item.date )}}</template>
        <template v-slot:cell(ID)="data">
          <b-link :to="{ name: 'invoiceView', params: { id: data.item.ID }}">{{ data.item.ID }}</b-link>
        </template>
        <template v-slot:cell(prixHTVA)="data">{{ twoDigits(data.item.prixHTVA)}} €</template>
        <template v-slot:cell(tva)="data">{{ data.item.tva * 100}} %</template>
        <template
          v-slot:cell(TVAC)="data"
        >{{ twoDigits(data.item.prixHTVA * (1 + Number(data.item.tva))) }} €</template>
        <template v-slot:cell(releve_compteID)="data">
          <b-link v-if="data.item.releve_compteID !==0" :to="{ name: 'accountStatementView', params: {id: data.item.releve_compteID }}"> {{ data.item.releve_compteID }}</b-link>
          <span v-else>N/A</span>
        </template>
        
      </b-table>
      <b-card-body v-else>
        <b-alert show>Pas de factures</b-alert>
      </b-card-body>
    <!-- </b-card> -->
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import creditors from "@/services/creditors.js";
export default {
  name: "creditor-invoices",
  props: ["id"],
  data() {
    return {
      loaded: false,
      invoices: [],
      invoicesFields: [
        {
          key: "date",
          label: "Date",
          sortable: true
        },
        {
          key: "ID",
          label: "Numéro",
          sortable: true
        },
        {
          key: "type",
          label: "Type",
          sortable: true
        },
        {
          key: "prixHTVA",
          label: "HTVA",
          class: "text-right",
          sortable: true
        },
        {
          key: "tva",
          label: "TVA",
          class: "text-right",
          sortable: true
        },
        {
          key: "TVAC",
          label: "TVAC",
          class: "text-right",
          sortable: true
        },
        {
          key: "releve_compteID",
          label: "Relevé de compte",
          sortable: false,
          class: "text-center"
        }
      ]
    };
  },
  created() {
    creditors.invoices(this.$props.id).then(response => {
      this.invoices = response.data;
      this.loaded = true;
    });
  },
  methods: {
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>